import React from 'react';
import PropTypes from 'prop-types';

import { IconButton, CopyOutlineIcon } from '@metarouter-private/mr-mui';

import { notify } from '@ion/api';

import WithTooltip from 'app/components/WithTooltip';

const DEFAULT_TOOLTIP_COPY = 'Copy to clipboard';
const DEFAULT_ICON_PROPS = { fontSize: 'small' };

export default function CopyToClipboard({
  text,
  tooltip = DEFAULT_TOOLTIP_COPY,
  IconButtonProps = {},
  IconProps = {},
}) {
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(text);

      notify.success({ message: 'Copied to clipboard' });
    } catch {
      notify.error({ message: 'Browser does not support copy-to-clipboard' });
    }
  };

  return (
    <WithTooltip show={Boolean(tooltip)} title={tooltip} noContainer>
      <IconButton {...IconButtonProps} onClick={onClick}>
        <CopyOutlineIcon {...DEFAULT_ICON_PROPS} {...IconProps} />
      </IconButton>
    </WithTooltip>
  );
}

CopyToClipboard.propTypes = {
  text: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  IconButtonProps: PropTypes.object,
  IconProps: PropTypes.object,
};
